import { Logger } from '../utilities/logger';
import mitt from 'mitt';
/**
 * Base for a component.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export class AbstractComponent {
    /**
     * @param {A11yConsentApi} api A11y Consent API
     * @param {HTMLElement} container Main container of the component
     */
    constructor(api, container) {
        // Emits events related to the component
        this.emitter = mitt();
        Logger.debug('component', 'Starting to construct.');
        this.container = container;
        this.api = api;
        Logger.debug('component', 'Finished constructing.');
    }
}
